import React, { useContext } from 'react'

import { FnaContext } from '../context'
import { Index } from './Index/index'
import { LifeCoverViews } from './LifeCover'
import { DisabilityCoverViews } from './DisabilityCover'
import { IncomeProtectionViews } from './IncomeProtection'
import { ASSESSMENT_TYPE } from '../reducer.js'

export const Views = () => {
  const {
    state: { view, assessmentType }
  } = useContext(FnaContext)

  return (
    {
      index: () => <Index />,
      [ASSESSMENT_TYPE.LIFE_COVER]: () => <LifeCoverViews />,
      [ASSESSMENT_TYPE.DISABILITY_COVER]: () => <DisabilityCoverViews />,
      [ASSESSMENT_TYPE.INCOME_PROTECTION]: () => <IncomeProtectionViews />
    }[assessmentType || view || 'index']()
  )
}
